import {FC, useState} from 'react'
import {PropertyRegistries} from '../../core/_models'
import {KTSVG} from '../../../../../../../../../../../_metronic/helpers'
import {ModalEditPropertyRegistries} from '../../../../modal/ModalEditPropertyRegistries'
type Props = {
  PropertyRegistries: PropertyRegistries
}
const PropertyRegistriesActionsCell: FC<Props> = ({PropertyRegistries}) => {
  const [showPropertiesRegisterModal, setPropertiesRegisterModal] = useState<boolean>(false)
  return (
    <>
      {/* <div className='d-flex flex-line align-items-center'> */}
      <a
        href={PropertyRegistries.path}
        title='Download'
        target='_blank'
        rel='noreferrer'
        className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm mx-2'
      >
        <i className='bi bi-eye-fill fs-2'></i>
      </a>
      <button
        title='Editar'
        className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm'
        onClick={() => setPropertiesRegisterModal(true)}
        data-bs-toggle='modal'
        data-bs-target='#kt_modal_edit_properties_registries'
      >
        <KTSVG path='/media/icons/duotune/art/art005.svg' className='svg-icon-3' />
      </button>
      <ModalEditPropertyRegistries
        id='propertiesRegistriesEdit'
        show={showPropertiesRegisterModal}
        handleClose={() => setPropertiesRegisterModal(false)}
        uuidRow={PropertyRegistries.uuid}
      />
    </>
  )
}

export {PropertyRegistriesActionsCell}
